import React from 'react';
import { Header, Table } from 'semantic-ui-react';

import { escribirMonto, imprimirMetodoDePago, imprimirMotivo } from '../../utilidades';
import { PagosEventualesDelDia } from '../tipos';

interface TablaPagosEventualesDelDiaProps {
    pagosEventualesDelDia: ReadonlyArray<PagosEventualesDelDia>;
    totalOtrosPagos: number;
}

const TablaPagosEventualesDelDia: React.FunctionComponent<TablaPagosEventualesDelDiaProps> = props => {
    const { pagosEventualesDelDia, totalOtrosPagos } = props;
    return (
        <div>
            <Header as='h4'>Otros pagos</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={6}>Motivo</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Forma de pago</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Monto</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Intereses</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Total</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {pagosEventualesDelDia.map((x, indice) => (
                        <FilaPagosPorArea key={indice} pagosEventualesDelDia={x} />
                    ))}
                    <Table.Row warning>
                        <Table.Cell>Total</Table.Cell>
                        <Table.Cell />
                        <Table.Cell />
                        <Table.Cell />
                        <Table.Cell>{escribirMonto(totalOtrosPagos)}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
};

interface FilaPagosPorAreaProps {
    pagosEventualesDelDia: PagosEventualesDelDia;
}

const FilaPagosPorArea: React.FunctionComponent<FilaPagosPorAreaProps> = props => {
    const { pagosEventualesDelDia } = props;
    let pagoTarjeta = '';
    if (pagosEventualesDelDia.metodoDePago._tipo === 'tarjeta') {
        pagosEventualesDelDia.metodoDePago._tipoDeTarjeta === 'debito'
            ? (pagoTarjeta = 'Débito')
            : (pagoTarjeta = 'Crédito');
    }
    return (
        <Table.Row>
            <Table.Cell>
                {pagosEventualesDelDia.motivo === 'otro'
                    ? pagosEventualesDelDia.otroMotivo!
                    : imprimirMotivo(pagosEventualesDelDia.motivo)}
            </Table.Cell>
            <Table.Cell>
                {pagosEventualesDelDia.metodoDePago._tipo === 'tarjeta'
                    ? pagoTarjeta
                    : imprimirMetodoDePago(pagosEventualesDelDia.formaDePago)}
            </Table.Cell>
            <Table.Cell>{escribirMonto(pagosEventualesDelDia.monto)}</Table.Cell>
            <Table.Cell>{escribirMonto(pagosEventualesDelDia.intereses)}</Table.Cell>
            <Table.Cell>{escribirMonto(pagosEventualesDelDia.montoTotal)}</Table.Cell>
        </Table.Row>
    );
};

export default TablaPagosEventualesDelDia;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaPagosEventualesDelDia.tsx